var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relatorios-main"},[_c('div',{staticClass:"relatorios-container"},[_c('relatorio-menu'),_c('div',{staticClass:"rel-page"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }